import { useMemo, useState } from 'react';
import { Button } from 'primereact/button';
import AnalyticsTimeRange from './AnalyticsTimeRange';
import Section from '../../../components/Backoffice/Display/Section';
import { SelectButton } from 'primereact/selectbutton';
import { CONSTANT } from '../../../utils/constants';
import AnalyticsFilter from './AnalyticsFilter';

function AnalyticsControls({ controls, setControls }) {
  // Save dates in local state
  const handleDates = (dates) => {
    setControls({
      ...controls,
      dates
    });
  };

  const handleTimeRangeMode = (value) => {
    setControls({
      ...controls,
      timeRangeMode: value
    });
  };

  return (
    <Section label="Paramètres" className="w-[400px]" showDivider={false}>
      <SelectButton
        value={controls.graphicType}
        onChange={(e) => setControls({ ...controls, graphicType: e.value })}
        options={CONSTANT.backoffice.analytics.graphicTypes}
        optionLabel="label"
        className="w-full flex flex-col"
        allowEmpty={false}
      />
      <AnalyticsFilter
        key="type"
        label="Type de résidences"
        options={CONSTANT.backoffice.residency.typeList}
        value={controls?.residencyTypeList}
        onChange={(value) => setControls({ ...controls, residencyTypeList: value })}
        emptyLabel="Tous les types"
      />
      <AnalyticsTimeRange
        key="timeRange"
        label="Période d'affichage"
        dates={controls.dates}
        mode={controls.timeRangeMode}
        handleDates={handleDates}
        handleMode={handleTimeRangeMode}
      />
    </Section>
  );
}

export default AnalyticsControls;
